<template>
  <div class="clientList">
    <!-- 头部 -->
    <div class="page-header">
      <div class="header-left">
        <div class="title">客户端管理</div>
        <a-tag color="green" class="status-tag">在线运行</a-tag>
      </div>
      <div class="header-right">
        <a-button type="primary" icon="plus" @click="handleAdd">新增客户端</a-button>
      </div>
    </div>

    <!-- 统计卡片 -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-label">客户端总数</div>
        <div class="stat-value">{{ stats.clientTotal || 0 }}</div>
        <div class="stat-trend" v-if="stats.clientTotalDelta">
          <span :class="stats.clientTotalDelta > 0 ? 'trend-up' : 'trend-down'">
            <span class="stats-trend-icon">{{ stats.clientTotalDelta > 0 ? '↑' : '↓' }}</span> 较上月 {{
              (stats.clientTotalDelta > 0 ? '+' : '') + Math.abs(stats.clientTotalDelta) }}
          </span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-label">服务设备数（台）</div>
        <div class="stat-value">{{ stats.serviceDeviceTotal || 0 }}</div>
        <div class="stat-trend" v-if="stats.serviceDeviceTotalDelta">
          <span :class="stats.serviceDeviceTotalDelta > 0 ? 'trend-up' : 'trend-down'">
            <span class="stats-trend-icon">{{ stats.serviceDeviceTotalDelta > 0 ? '↑' : '↓' }}</span>{{
              (stats.serviceDeviceTotalDelta > 0 ? '+' : '') + Math.abs(stats.serviceDeviceTotalDelta) }}
          </span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-label">接入设备型号数（个）</div>
        <div class="stat-value">{{ stats.accessTypeTotal || 0 }}</div>
        <div class="stat-trend" v-if="stats.accessTypeTotalDelta">
          <span :class="stats.accessTypeTotalDelta > 0 ? 'trend-up' : 'trend-down'">
            <span class="stats-trend-icon">{{ stats.accessTypeTotalDelta > 0 ? '↑' : '↓' }}</span>{{
              (stats.accessTypeTotalDelta > 0 ? '+' : '') + Math.abs(stats.accessTypeTotalDelta) }}
          </span>
        </div>
      </div>
    </div>

    <div class="table-box">
      <!-- 搜索区 -->
      <div class="search-panel">
        <a-form :form="form" layout="inline">
          <a-form-item>
            <a-input v-decorator="['keyword']" placeholder="搜索客户端名称 / AppID" allow-clear style="width: 200px"
              @pressEnter="handleSearch"></a-input>
          </a-form-item>
          <a-form-item>
            <a-select v-decorator="['clientCategory']" placeholder="全部分类" allow-clear style="width: 140px">
              <a-select-option v-for="item in categoryOptions" :key="item.value" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-decorator="['clientType']" placeholder="全部类型" allow-clear style="width: 140px">
              <a-select-option v-for="item in typeOptions" :key="item.value" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-decorator="['status']" placeholder="全部状态" allow-clear style="width: 140px">
              <a-select-option value="ENABLED">启用</a-select-option>
              <a-select-option value="DISABLED">停用</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-input v-decorator="['tenantName']" placeholder="归属租户名称" allow-clear style="width: 180px"
              @pressEnter="handleSearch"></a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" icon="search" @click="handleSearch">查询</a-button>
            <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
          </a-form-item>
        </a-form>
      </div>

      <!-- 表格 -->
      <a-table :columns="columns" :data-source="clientList" :rowKey="(record) => record.id" :pagination="pagination"
        @change="handleTableChange" :scroll="{ x: 1200 }" size="middle">
        <span slot="index" slot-scope="text, record, idx">{{ (pagination.current - 1) * pagination.pageSize + idx + 1
          }}</span>
        <span slot="clientId" slot-scope="text" class="mono-text">{{ text || '--' }}</span>
        <span slot="clientName" slot-scope="text">{{ text || '--' }}</span>
        <span slot="clientCategory" slot-scope="text">
          <a-tag v-if="text" color="orange">{{ getCategoryLabel(text) }}</a-tag>
          <span v-else>--</span>
        </span>
        <span slot="clientType" slot-scope="text">
          <a-tag v-if="text" :color="getTypeColor(text)"><a-icon :type="getTypeIcon(text)" style="margin-right: 5px;" />{{ getTypeLabel(text) }}</a-tag>
          <span v-else>--</span>
        </span>
        <span slot="serviceDeviceCount" slot-scope="text">{{ formatNumber(text) || 0 }}</span>
        <span slot="accessTypeCount" slot-scope="text">{{ text || 0 }}</span>
        <span slot="status" slot-scope="text">
          <span v-if="text == 'ENABLED'" class="status-enable">● 启用</span>
          <span v-else class="status-disable">● 停用</span>
        </span>
        <span slot="lastOperator" slot-scope="text">{{ text || '--' }}</span>
        <span slot="updateTime" slot-scope="text">{{ text ? $moment(text).format('YYYY-MM-DD HH:mm:ss') : '--' }}</span>
        <span slot="action" slot-scope="text, record">
          <a @click="toDetail(record)">查看详情</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>
        </span>
      </a-table>
    </div>

    <!-- 新增/编辑弹窗 -->
    <add-client :visible="addEditVisible" :record="currentRecord" @close="addEditVisible = false"
      @refresh="refreshList" />

  </div>
</template>

<script>
import AddClient from './modal/addClient.vue'
import DeleteClient from './modal/deleteClient.vue'
import { CLIENT_TYPES, CLIENT_CATEGORIES } from './clientConstants.js'

const columns = [
  { title: '序号', key: 'index', scopedSlots: { customRender: 'index' }, width: 60, align: 'center' },
  { title: 'ClientId', dataIndex: 'clientId', key: 'clientId', scopedSlots: { customRender: 'clientId' }, width: 220 },
  { title: '客户端名称', dataIndex: 'clientName', key: 'clientName', scopedSlots: { customRender: 'clientName' }, width: 160, sorter: true },
  { title: '客户端分类', dataIndex: 'clientCategory', key: 'clientCategory', scopedSlots: { customRender: 'clientCategory' }, width: 130 },
  { title: '客户端类型', dataIndex: 'clientType', key: 'clientType', scopedSlots: { customRender: 'clientType' }, width: 140 },
  { title: '服务设备数', dataIndex: 'serviceDeviceCount', key: 'serviceDeviceCount', scopedSlots: { customRender: 'serviceDeviceCount' }, width: 110 },
  { title: '接入型号数', dataIndex: 'accessTypeCount', key: 'accessTypeCount', scopedSlots: { customRender: 'accessTypeCount' }, width: 110 },
  { title: '状态', dataIndex: 'status', key: 'status', scopedSlots: { customRender: 'status' }, width: 100, align: 'center' },
  { title: '最后操作人', dataIndex: 'lastOperator', key: 'lastOperator', scopedSlots: { customRender: 'lastOperator' }, width: 180 },
  { title: '更新时间', dataIndex: 'updateTime', key: 'updateTime', scopedSlots: { customRender: 'updateTime' }, width: 150 },
  { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }, width: 150, fixed: 'right', align: 'center' },
]

export default {
  name: 'ClientList',
  components: { AddClient, DeleteClient },
  data() {
    return {
      form: this.$form.createForm(this),
      columns,
      clientList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
        pageSizeOptions: ['10', '20', '30', '50'],
      },
      // 统计数据
      stats: {
        clientTotal: 0,
        serviceDeviceTotal: 0,
        accessTypeTotal: 0,
        clientTotalDelta: null,
        serviceDeviceTotalDelta: null,
        accessTypeTotalDelta: null,
      },
      // 下拉选项
      typeOptions: CLIENT_TYPES,
      categoryOptions: CLIENT_CATEGORIES,
      // 弹窗控制
      addEditVisible: false,
      // deleteVisible: false,
      currentRecord: null,
      clientNameSorter: null, // 客户端名称排序
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      await Promise.all([this.getList(), this.getStats()])
    },

    /* 获取列表 */
    getList() {
      let params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        sortOrder: this.clientNameSorter,
      }
      let formValues = this.form.getFieldsValue()
      formValues = this.cleanEmpty(formValues)
      params = { ...params, ...formValues }

      return new Promise((resolve) => {
        this.$api.getClientListData(params).then((res) => {
          if (res && res.code == 0) {
            this.clientList = res.data.records || []
            this.pagination.total = Number(res.data.total || 0)
          }
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    },

    /* 获取统计 */
    getStats() {
      return new Promise((resolve) => {
        this.$api.getClientStats().then((res) => {
          if (res && res.code == 0) {
            this.stats = { ...this.stats, ...res.data }
          }
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    },

    /* 刷新列表 */
    refreshList() {
      this.addEditVisible = false
      // this.deleteVisible = false
      this.currentRecord = null
      this.getList()
      this.getStats()
    },

    /* 搜索 */
    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },

    /* 重置 */
    handleReset() {
      this.form.resetFields()
      this.pagination.current = 1
      this.getList()
    },

    /* 分页 */
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize

      const order = sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : null
      this.clientNameSorter = sorter.field === 'clientName' ? order : null

      this.getList()
    },

    /* 新增 */
    handleAdd() {
      this.currentRecord = null
      this.addEditVisible = true
    },

    /* 编辑 */
    handleEdit(record) {
      this.currentRecord = record
      this.addEditVisible = true
    },

    /* 跳转详情 */
    toDetail(record) {
      this.$router.push({
        name: 'ClientDetail',
        query: { id: record.id },
      })
    },

    /* 工具方法 */
    getTypeLabel(value) {
      const t = CLIENT_TYPES.find((i) => i.value === value)
      return t ? t.label : value
    },
    getTypeIcon(value) {
      const t = CLIENT_TYPES.find((i) => i.value === value)
      return t ? t.icon : 'user'
    },
    getTypeColor(value) {
      const t = CLIENT_TYPES.find((i) => i.value === value)
      return t ? t.color : 'blue'
    },
    getCategoryLabel(value) {
      const t = CLIENT_CATEGORIES.find((i) => i.value === value)
      return t ? t.label : value
    },
    formatNumber(val) {
      if (!val) return 0
      return Number(val).toLocaleString()
    },
    cleanEmpty(obj) {
      return Object.keys(obj)
        .filter((k) => obj[k] !== undefined && obj[k] !== '' && obj[k] !== null)
        .reduce((prev, curr) => ({ ...prev, [curr]: obj[curr] }), {})
    },
  },
}
</script>

<style lang="less" scoped>
@import '@/assets/CSS/global.less';

.clientList {
  background-color: #f5f6f8;
  height: calc(100vh - 109px);
  padding: 16px;
  border-radius: 4px;
  overflow-y: auto;
  margin: 0 -10px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  .header-left {
    display: flex;
    align-items: center;
    gap: 12px;

    .title {
      font-size: 20px;
      font-weight: 600;
      color: #151515;
    }

    .status-tag {
      font-size: 12px;

      &::before {
        // 增加一个圆形背景
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 4px;
        background-color: #52c41a;
      }
    }
  }
}

.stats-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;

  .stat-card {
    flex: 1;
    border: 1px solid #fff;
    border-radius: 6px;
    padding: 16px 20px;
    background: #fff;

    .stat-label {
      font-size: 14px;
      color: #6b7280;
      margin-bottom: 8px;
    }

    .stat-value {
      font-size: 24px;
      font-weight: 600;
      color: #111827;
      line-height: 1.2;
    }

    .stat-trend {
      margin-top: 6px;
      font-size: 12px;

      .trend-up {
        color: #16a34a;
      }

      .trend-down {
        color: #ff4d4f;
      }

      .stats-trend-icon {
        position: relative;
        top: -2px;
        font-weight: 600;
        margin-right: 3px;
      }
    }
  }
}

.table-box {
  border-radius: 4px;
  background-color: #fff;
}

.search-panel {
  border-radius: 4px;
  padding: 12px 16px;
  background: #fff;
}

.mono-text {
  font-family: Menlo, Monaco, Consolas, monospace;
}

.status-enable {
  color: #52c41a;
}

.status-disable {
  color: #bfbfbf;
}

.delete-link {
  color: #ff4d4f;
}

.delete-link:hover {
  color: #ff7875;
}
</style>
